export default function displayError(msg: string): void {
  // eslint-disable-next-line no-alert
  alert(msg);
}
